var _circle, _circle2, _g, _g2, _g3, _g4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoAttachments(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 142,
    height: 158,
    viewBox: "0 0 142 158",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 71,
    cy: 87,
    r: 71,
    fill: "#EBEBEB"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7892_32167",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 16,
    width: 142,
    height: 142
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 71,
    cy: 87,
    r: 71,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7892_32167)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22 106.53C22 100.367 26.9965 95.3701 33.16 95.3701H49.8242C52.2855 95.3701 54.6777 96.1838 56.6286 97.6844L62.7014 102.356C64.6523 103.856 67.0445 104.67 69.5058 104.67H103.84C110.004 104.67 115 109.667 115 115.83V141.87C115 148.034 110.004 153.03 103.84 153.03H33.16C26.9965 153.03 22 148.034 22 141.87V106.53Z",
    fill: "#928165"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.9682 138.481H36.6513C34.6349 138.481 33 136.847 33 134.83V76.6513C33 74.6349 34.6349 73 36.6513 73H98.9682C100.985 73 102.62 74.6349 102.62 76.6513V134.83C102.62 136.847 100.985 138.481 98.9682 138.481Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.2998 85.2922H44.3184V87.9697H91.2998V85.2922ZM91.2998 95.5155H44.3184V98.193H91.2998V95.5155ZM91.2998 105.741H44.3184V108.419H91.2998V105.741ZM91.2998 115.964H44.3184V118.642H91.2998V115.964Z",
    fill: "#DFDEDC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45 67V73H42V67C42 62.58 45.58 59 50 59C54.42 59 58 62.58 58 67V88C58 90.76 55.76 93 53 93C50.24 93 48 90.76 48 88V69H51V88C51 89.1 51.89 90 53 90C54.11 90 55 89.1 55 88V67C55 64.24 52.76 62 50 62C47.24 62 45 64.24 45 67Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5226 126.62C14.7191 121.016 19.067 116 24.7284 116H111.46C117.056 116 121.385 120.906 120.688 126.458L116.021 163.658C115.438 168.31 111.482 171.8 106.794 171.8H30.0618C25.4354 171.8 21.5125 168.399 20.8559 163.82L15.5226 126.62Z",
    fill: "#F5B953"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7892_32167)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.0126 29.2561L55.576 28.8726L53.8435 24.8085C53.5318 24.0687 52.4685 24.0687 52.1568 24.8085L50.4243 28.8817L45.9968 29.2561C45.1901 29.3201 44.8601 30.3247 45.4743 30.8544L48.8385 33.7586L47.8301 38.0693C47.6468 38.8547 48.4993 39.4757 49.196 39.0556L53.0001 36.7724L56.8043 39.0648C57.501 39.4849 58.3535 38.8638 58.1701 38.0784L57.1618 33.7586L60.526 30.8544C61.1401 30.3247 60.8193 29.3201 60.0126 29.2561Z",
    fill: "#FF5000"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_7892_32167)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80.4619 5.25396L77.6385 5.00986L76.536 2.42362C76.3377 1.95287 75.661 1.95287 75.4627 2.42362L74.3602 5.01567L71.5427 5.25396C71.0294 5.29464 70.8194 5.93393 71.2102 6.27102L73.351 8.11916L72.7094 10.8623C72.5927 11.3621 73.1352 11.7573 73.5785 11.49L75.9994 10.037L78.4202 11.4958C78.8635 11.7631 79.406 11.3679 79.2894 10.8681L78.6477 8.11916L80.7885 6.27102C81.1794 5.93393 80.9752 5.29464 80.4619 5.25396Z",
    fill: "#FF5000"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_7892_32167)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M99.3503 41.6196L93.1062 41.0798L90.6678 35.36C90.2292 34.3188 88.7326 34.3188 88.294 35.36L85.8557 41.0926L79.6244 41.6196C78.4891 41.7096 78.0246 43.1235 78.889 43.869L83.6238 47.9564L82.2046 54.0233C81.9466 55.1287 83.1464 56.0027 84.1269 55.4115L89.4809 52.1981L94.8349 55.4243C95.8154 56.0156 97.0152 55.1415 96.7572 54.0361L95.3381 47.9564L100.073 43.869C100.937 43.1235 100.486 41.7096 99.3503 41.6196Z",
    fill: "#FF5000"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7892_32167"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 21,
    width: 22,
    height: 21.9187,
    rx: 2,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_7892_32167"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 69,
    width: 14,
    height: 13.9483,
    rx: 2,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_7892_32167"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 74,
    y: 30,
    width: 30.9629,
    height: 30.8485,
    rx: 2,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoAttachments);
export default __webpack_public_path__ + "static/media/NoAttachments.305c3b1d2e614c528e834b797bd5139e.svg";
export { ForwardRef as ReactComponent };